import { useState } from 'react';

const FontSizeSlider = () => {
  const [fontSize, setFontSize] = useState(16);

  const handleChange = (e) => {
    const value = parseInt(e?.target?.value);
    setFontSize(value);
    document.documentElement.style.fontSize = `${value}px`;
  };

  return (
    <div className="w-full max-w-xs">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs md:text-sm text-muted-foreground">Small</span>
        <span className="text-xs md:text-sm font-medium text-foreground">{fontSize}px</span>
        <span className="text-xs md:text-sm text-muted-foreground">Large</span>
      </div>
      <input
        type="range"
        min="12"
        max="20"
        value={fontSize}
        onChange={handleChange}
        className="w-full h-2 rounded-lg appearance-none cursor-pointer"
        style={{
          background: `linear-gradient(to right, var(--color-primary) 0%, var(--color-primary) ${((fontSize - 12) / 8) * 100}%, var(--color-muted) ${((fontSize - 12) / 8) * 100}%, var(--color-muted) 100%)`
        }}
        aria-label="Font size slider"
      />
    </div>
  );
};

export default FontSizeSlider;